import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-notification-permission-dialog',
  template: `
    <h2 mat-dialog-title>
      <mat-icon style="vertical-align: middle; margin-right: 8px;">notifications_off</mat-icon>
      Enable Notifications
    </h2>
    <mat-dialog-content>
      <p>To receive notifications, please enable them in your browser settings.</p>
      <div style="margin: 16px 0; padding: 16px; background-color: #f5f5f5; border-radius: 4px;">
        <strong>Instructions for {{ data.browserName }}:</strong>
        <ol style="margin: 8px 0 0 0; padding-left: 20px;">
          <li *ngFor="let step of data.instructions">{{ step }}</li>
        </ol>
      </div>
      <p style="margin-top: 16px; font-size: 0.9em; color: #666;">
        After enabling notifications, click "Try Again" to request permission.
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button [mat-dialog-close]="false">Maybe Later</button>
      <button mat-button [mat-dialog-close]="true" color="primary">
        <mat-icon style="vertical-align: middle; margin-right: 4px;">refresh</mat-icon>
        Try Again
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    mat-dialog-content {
      min-width: 400px;
    }
    ol {
      line-height: 1.8;
    }
  `]
})
export class NotificationPermissionDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<NotificationPermissionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      browserName: string;
      instructions: string[];
    }
  ) {}
}

